var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4118 11.768C40.4118 11.768 40.0236 8.98858 38.8301 7.76482C37.3156 6.16069 35.6195 6.15124 34.8417 6.06028C29.2702 5.65039 20.9137 5.65039 20.9137 5.65039H20.8951C20.8951 5.65039 12.5386 5.65039 6.9684 6.06028C6.19062 6.15124 4.49567 6.16069 2.97993 7.76482C1.78774 8.98858 1.39823 11.768 1.39823 11.768C1.39823 11.768 1 15.0295 1 18.2909V21.3479C1 24.6117 1.39823 27.8719 1.39823 27.8719C1.39823 27.8719 1.78649 30.6502 2.97993 31.8716C4.49567 33.4758 6.48306 33.4273 7.36911 33.5951C10.5537 33.9045 20.905 34.0002 20.905 34.0002C20.905 34.0002 29.2702 33.9861 34.8417 33.5809C35.6195 33.4864 37.3156 33.4769 38.8301 31.8728C40.0223 30.6514 40.4118 27.8731 40.4118 27.8731C40.4118 27.8731 40.8101 24.6117 40.8101 21.3491V18.2921C40.8101 15.0295 40.4118 11.768 40.4118 11.768Z",
    fill: "#E02F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9333 12.7378V26.9127L28.3779 19.8253L15.9333 12.7378Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e81f8471.svg";
export { ForwardRef as ReactComponent };